import { Routes, RouterModule } from '@angular/router';
import {IndexComponent} from './pages/index/index.component';
import {LoginComponent} from './pages/login/login.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { UserDashboardComponent } from './pages/user-dashboard/user-dashboard.component';

import { AuthGuard } from './_guards/index';
import { CanDeactivateGuard } from './_guards/index';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { SignupComponent } from './pages/signup/signup.component';
import { ResetComponent } from './pages/reset/reset.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PersonalInformationComponent } from './pages/profile/personal-information/personal-information.component';
import { AcademicInformationComponent } from './pages/profile/academic-information/academic-information.component';
import { BackgroundInformationComponent } from './pages/profile/background-information/background-information.component';
import { PriorHigherEducationComponent } from './pages/profile/prior-higher-education/prior-higher-education.component';
import { FutureCollegePlansComponent } from './pages/profile/future-college-plans/future-college-plans.component';
import { AcademicCareerGoalsComponent } from './pages/profile/academic-career-goals/academic-career-goals.component';
import { ExtracurricullarActivitiesComponent } from './pages/profile/extracurricullar-activities/extracurricullar-activities.component';
import { EmploymentComponent } from './pages/profile/employment/employment.component';
import { StudentChecklistComponent } from './pages/student-checklist/student-checklist.component';
import { StudentDefaultChecklistComponent } from './pages/student-default-checklist/student-default-checklist.component';
import { PartnerQuestionsComponent } from './pages/profile/partner-questions/partner-questions.component';
import { SarUploadComponent } from './pages/sar-upload/sar-upload.component';
import { StudentCalculatorComponent } from './pages/student-calculator/student-calculator.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './pages/terms-condition/terms-condition.component';
import { ScholarshipAcceptanceComponent } from './pages/scholarship-acceptance/scholarship-acceptance.component';
import { StudentResourceComponent } from './pages/student-resource/student-resource.component';
import { StudentOpportunitiesComponent } from './pages/student-opportunities/student-opportunities.component';
import { StudentNewDashboardComponent} from './pages/student-new-dashboard/student-new-dashboard.component';
import { RequestDocumentComponent} from './pages/request-document/request-document.component';
import { from } from 'rxjs/observable/from';
export const routes = [
    {path: 'index', component: IndexComponent},
    {path: '', component: IndexComponent },
    {path: 'student-new-dashboard', component: StudentNewDashboardComponent },
    {path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuard]},
    {path: 'dashboard', component: UserDashboardComponent, canActivate: [AuthGuard]},
    {path: 'login', component: LoginComponent},
    {path: 'forgot-password', component: ForgotComponent},
    {path: 'reset-password', component: ResetComponent},
    {path: 'sign-up', component: SignupComponent},
    {path: 'resources', component: ResourcesComponent},
    {path: 'Request-Document/:token', component: RequestDocumentComponent},
    {path: 'privacy-policy', component: PrivacyPolicyComponent },
    {path: 'terms-condition', component: TermsConditionComponent },
    {path: 'student-resources', component: StudentResourceComponent },
    {path: 'student-resources/:rid', component: StudentResourceComponent },
    {path: 'student-opportunities', component: StudentOpportunitiesComponent },
    {path: 'student-opportunities/:oid', component: StudentOpportunitiesComponent },
    {path: 'user-dashboard', component: StudentNewDashboardComponent, canActivate: [AuthGuard]},
    {path: 'student-checklist/:lid', component: StudentChecklistComponent, canActivate: [AuthGuard]},
    {path: 'student-checklists', component: StudentDefaultChecklistComponent, canActivate: [AuthGuard]},
    {path: 'profile-upload', component: SarUploadComponent, canActivate: [AuthGuard]},
    {path: 'student-calculator', component: StudentCalculatorComponent, canActivate: [AuthGuard]},
    {path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard]},
    {path: 'scholarship-acceptance/:hash', component: ScholarshipAcceptanceComponent, canActivate: [AuthGuard]},
    {path: 'profile',redirectTo:'profile/'},
    {path: 'profile/:sectionName',component: ProfileComponent,canActivate: [AuthGuard]},
    {pathMatch: 'full', path: '**', redirectTo: '' }

];



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/app.routes.ts